import React from "react";
import { Text, TouchableOpacity } from "react-native";
import { Image } from "expo-image";
import "../global.css";

interface GoogleButtonProps {
  onPress: () => void;
}

const GoogleButton = ({ onPress }: GoogleButtonProps) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      className="flex-row items-center justify-center bg-white border border-gray-200 rounded-xl py-3 px-4"
    >
      <Image
        source={require("../assets/images/google.png")}
        style={{ width: 20, height: 20 }}
      />
      <Text className="ml-2 text-gray-700">Login with Google</Text>
    </TouchableOpacity>
  );
};

export default GoogleButton;
